import { AffectedProduct } from 'types';

/** Gets the CVSS version number from a product */
export const cvssVersion = (
  product: Partial<Pick<AffectedProduct, 'vectorString'>> | undefined
): string | null => {
  if (!product?.vectorString) {
    return null;
  }
  const vs = product.vectorString?.toUpperCase();
  const cvssIndex = vs.indexOf('CVSS');
  const cvssEnd = vs.indexOf('/', cvssIndex);
  /** string text containing 'CVSS:##' */
  return vs.substring(cvssIndex, cvssEnd);
  //uncomment if we actually need the value later
  // return versionMetric?.substring(versionMetric.indexOf(':') + 1).trim();
};
